package dev.danko.roblox_craft_ai.pages.legal.en

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initRefundsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("legal/en/refunds.md", FrontMatterElement.Builder { addScalar("title", "Refund Policy"); addScalar("lang", "en"); }))
}

@Page("/legal/en/refunds")
@Layout(".components.layouts.LegalLayout")
@Composable
fun RefundsPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("refund-policy") }) {
        org.jetbrains.compose.web.dom.Text("Refund Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Effective date:")
        }
        org.jetbrains.compose.web.dom.Text(" 3 October 2026")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Payments for Craftiva AI are processed by ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Paddle.com")
        }
        org.jetbrains.compose.web.dom.Text(", our Merchant of Record. Paddle issues refunds according to this policy and handles all payment questions.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("14-day-refund") }) {
        org.jetbrains.compose.web.dom.Text("14-day refund")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can get a full refund within ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("14 days")
        }
        org.jetbrains.compose.web.dom.Text(" of a purchase if you have used ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("no more than 20%")
        }
        org.jetbrains.compose.web.dom.Text(" of the credits from that purchase:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Subscription")
            }
            org.jetbrains.compose.web.dom.Text(": no more than 20% of the monthly credits of the billing period you are asking about. This applies to the first payment and to each renewal.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Credit pack")
            }
            org.jetbrains.compose.web.dom.Text(": no more than 20% of the credits in the pack.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After a refund, the unspent credits from that purchase are removed from your account, and a refunded subscription is cancelled.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("cancelling-a-subscription") }) {
        org.jetbrains.compose.web.dom.Text("Cancelling a subscription")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can cancel at any time on the ")
        com.varabyte.kobweb.silk.components.navigation.Link("/pricing") {
            org.jetbrains.compose.web.dom.Text("Pricing page")
        }
        org.jetbrains.compose.web.dom.Text(" (\"Manage subscription\") or through the link in your Paddle receipt. After cancelling, your plan stays active until the end of the paid period, and you will not be charged again. Cancelling on its own does not refund the current period; use the 14-day refund above if it applies.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("failed-generations") }) {
        org.jetbrains.compose.web.dom.Text("Failed generations")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If a generation fails because of an error on our side, its credits are returned to your balance automatically. You do not need to request this.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("exceptions") }) {
        org.jetbrains.compose.web.dom.Text("Exceptions")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may refuse a refund in cases of abuse, such as repeated purchases and refunds or using most of the credits before asking for a refund. Accounts closed for breaking the ")
        com.varabyte.kobweb.silk.components.navigation.Link("/legal/en/terms") {
            org.jetbrains.compose.web.dom.Text("Terms of Service")
        }
        org.jetbrains.compose.web.dom.Text(" are not eligible. This does not affect your rights under consumer protection law where you live.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("how-to-request-a-refund") }) {
        org.jetbrains.compose.web.dom.Text("How to request a refund")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Write to [SUPPORT_EMAIL] from the email address of your account and include the order number from your Paddle receipt, or contact Paddle directly at ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://paddle.net") {
            org.jetbrains.compose.web.dom.Text("paddle.net")
        }
        org.jetbrains.compose.web.dom.Text(". Refunds go back to the original payment method, usually within 5–10 business days depending on your bank.")
    }
}
